<template>
  <div class="form" style="text-align:left;">
    <div class="title is-4">{{title}}</div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="subject">
          <b-input maxlength="255" v-model="item.subject"></b-input>
        </b-field>
      </div>
      <div class="column" style="text-align:left;">
        <b-field label="Pflichtangaben-Verzicht">
          <div class="field">
            <b-checkbox v-model="item.pflichtangabenVerzicht"
                        true-value="true"
                        false-value="false">
              {{item.pflichtangabenVerzicht}}
            </b-checkbox>
          </div>
        </b-field>
      </div>
      <div class="column" style="text-align:left;">
        <b-field label="Virenprüfung-Processed">
          <div class="field">
            <b-checkbox v-model="item.clamavProcessed"
                        true-value="true"
                        false-value="false">
              {{item.clamavProcessed}}
            </b-checkbox>
          </div>
        </b-field>
      </div>
      <div class="column" style="text-align:left;">
        <b-field label="Dropbox-Processed">
          <div class="field">
            <b-checkbox v-model="item.dropboxProcessed"
                        true-value="true"
                        false-value="false">
              {{item.dropboxProcessed}}
            </b-checkbox>
          </div>
        </b-field>
      </div>
      <div class="column" style="text-align:left;">
        <b-field label="Zoho-Processed">
          <div class="field">
              <b-checkbox v-model="item.zohoProcessed"
                  true-value="true"
                  false-value="false">
                  {{item.zohoProcessed}}
              </b-checkbox>
          </div>
        </b-field>
      </div>
      <div class="column" style="text-align:left;">
        <b-field label="Copydruck-Processed">
          <div class="field">
              <b-checkbox v-model="item.copydruckProcessed"
                  true-value="true"
                  false-value="false">
                  {{item.copydruckProcessed}}
              </b-checkbox>
          </div>
        </b-field>
      </div>
      <div class="column" style="text-align:left;">
        <b-field label="Virus-Detected">
          <div class="field">
            <b-checkbox v-model="item.virusDetected"
                        true-value="true"
                        false-value="false">
              {{item.virusDetected}}
            </b-checkbox>
          </div>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column" >
        <b-button type="is-primary" v-on:click="save()" :disabled="loading">Speichern</b-button>
      </div>
    </div>

  </div>
</template>


<script>
// @ is an alias to /src

import Vue from 'vue'

const axios = require('axios');


export default {
  name: "SingleCommission",
  components: {

},
data() {
      return {
          title: "Neuen Auftrag anlegen",
          item: {},
          loading: true,
        //  item: { 'id': 22, 'name': 'Beidseitig individuelles Kartenset', 'spielart': 'Kartenspiel', 'date': '2016-10-15 13:43:27' },
      }
  },
  watch: {

  },
  mounted: function() {
    console.log("FORM "+ this.$route.params.id);
    if (this.$route.params.id) {
      this.title = "Auftrag bearbeiten";
      //Get-Game
      var _this = this;
      axios.get('/api/imageuploads/'+this.$route.params.id, {
        withCredentials: true,
      })
      .then(function (response) {
        console.log(response.data);
        _this.item = response.data;
          _this.loading = false;

      })
      .catch(function (error) {
        console.log(error);
      })
      .then(function () {
        // always executed
      });
    } else {
        this.loading = false;
    }

  },
  methods: {
    save: function() {

        //Set-Package
        var _this = this;
        var url = '/api/imageuploads';


        console.log("SAVE");
        console.log(url);
        console.log(this.item);

        axios.put(url, this.item, {
          headers: {
            'Content-Type': 'application/json',
          },
          withCredentials: true,
        })
        .then(function (response) {
          console.log(response.data);
          _this.$router.push({ name: 'commissions' })
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
        });


    }
  }
};

</script>
